﻿function isCampaignEditor() {
    return parent.location.href.toLowerCase().indexOf("campaigneditor/") > -1 || parent.location.href.toLowerCase().indexOf("/campaigns/editor") > -1 || parent.location.href.toLowerCase().indexOf("/dynamix/app#/campaigns/content/") > -1;
}

function isFormEditor() {
    return window.location.href.toLowerCase().indexOf("formeditor/") > -1 || window.location.href.toLowerCase().indexOf("eventforms/") > - 1;
}

function isEventLayoutEditor() {
    return window.location.href.toLowerCase().indexOf("eventlayouts/editor") > -1;
}

function isLandingPageEditor() {
    return window.location.href.toLowerCase().indexOf("landingpages/editor") > -1;
}

export { isCampaignEditor, isFormEditor, isEventLayoutEditor, isLandingPageEditor };